import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { type CSSProperties } from 'react';

import { Box } from '../box/Box';

export type FlexProps = {
  display?: CSSProperties['display'];
  gap?: CSSProperties['gap'];
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
  wrap?: CSSProperties['flexWrap'];
  direction?: CSSProperties['flexDirection'];
  columnGap?: CSSProperties['columnGap'];
  rowGap?: CSSProperties['rowGap'];
};

export const Flex = styled(Box)<FlexProps>`
  ${(p) => css`
    display: ${p.display || 'flex'};
    column-gap: ${p.columnGap || 0};
    row-gap: ${p.rowGap || 0};
    gap: ${p.gap || 0};
    align-items: ${p.align || 'center'};
    justify-content: ${p.justify || 'flex-start'};
    flex-wrap: ${p.wrap || 'nowrap'};
    flex-direction: ${p.direction || 'row'};
    column-gap: ${p.columnGap || 'auto'};
    row-gap: ${p.rowGap || 'auto'};
  `};
`;
